export default __webpack_public_path__ + "static/media/Rename.c42add5a.svg";